// extracted by mini-css-extract-plugin
export var copyable = "_u-1";
export var explainable = "_u-0";
export var negative = "_u-2";
export var positive = "_u-3";